import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterByTypeModal } from "../../../store/documentsSignerList";
import { selectTypeFilter } from "../../../store/documentsSignerList/selectors/selectTypeFilter";

export const FilterTypeChip = () => {
  const typeFilter = useSelector(selectTypeFilter);
  const dispatch = useDispatch();
  return (
    <IonChip
      onClick={() => dispatch(setFilterByTypeModal(true))}
      outline
      color={typeFilter?.length ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {typeFilter?.length ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Tipo: </span>
            {typeFilter?.map(
              (typeItem, index) => typeItem.name + (typeFilter?.length === index + 1 ? "" : ", ")
            )}
          </IonText>
        ) : (
          <span>Tipo: Todos</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
